import 'slick-carousel'

export default () => {

  $('.left-right-slider').each(function() {
    let $slick = $(this).find('.slider-wrapper');
    let $bottomImage = $(this).find('.slider-nav');
    let $testSwiper = $(this).find('.left-right-swiper');
    let $previousImage = $testSwiper.find('.icon-prev')
    let $nextImage = $testSwiper.find('.icon-next')

    if ($('.slider-wrapper .image').length > 1) {
      $slick.slick ({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        dots: false,
        asNavFor: $bottomImage,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '25px',
              dots: false,
              adaptiveHeight: true,
            },
          },
        ],
      });

      $bottomImage.slick ({
        slidesToShow: 3,
        arrows: true,
        autoplay: false,
        prevArrow: $previousImage,
        nextArrow: $nextImage,
        asNavFor: $slick,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  })
}



// WEBPACK FOOTER //
// ./scripts/layouts/left-right-slider.js